import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { MoveTrailFill } from "./MoveTrailFill";
export var MoveTrail = /*#__PURE__*/function () {
  function MoveTrail() {
    _classCallCheck(this, MoveTrail);

    this.enable = false;
    this.length = 10;
    this.fill = new MoveTrailFill();
  }

  _createClass(MoveTrail, [{
    key: "fillColor",
    get: function get() {
      return this.fill.color;
    },
    set: function set(value) {
      this.fill.load({
        color: value
      });
    }
  }, {
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.fill !== undefined || data.fillColor !== undefined) {
        this.fill.load(data.fill || {
          color: data.fillColor
        });
      }

      if (data.length !== undefined) {
        this.length = data.length;
      }
    }
  }]);

  return MoveTrail;
}();